import { connect } from 'react-redux';
import { push as historyPush } from 'react-router-redux';
import BlockContent from './BlockContent';

const connected = connect(null, {
  historyPush,
})(BlockContent);

export default connected;
